import ImageBase from '@/models/image/image-base'
import { IImageState } from './interfaces/image-state'

export default class ImageState implements IImageState {
  public uploadedImages: ImageBase[] = []
  public failedUploads: ImageBase[] = []
  public imagesToUpload: ImageBase[] = []
  public isImageUploading = false
}
